import React, { useState, useEffect, useContext } from 'react';
import { useRouteMatch } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { AuthContext } from '../../commons/auth/AuthContext';
import {
    createToPDigitalSignatureContract,
    getToPDigitalSignatureContract,
    getToPDigitalSignatureSigningUrl,
} from '../onboardingRoutes';
import { SIGN_STATUS } from '../../commons/digitalSignature/DigitalSignatureStatus';
import {
    SignStatusCheck,
    SignWithAdobeSignButton,
    DocumentSignedButton,
} from '../../commons/digitalSignature/DigitalSignatureComponents';
import AdobeSignRedirectDisclaimer from '../../commons/digitalSignature/AdobeSignRedirectDisclaimer';

const SignToPViaDigitalSignatureButton = (props) => {
    const routeMatch = useRouteMatch();
    const { url } = routeMatch.params;

    const authContext = useContext(AuthContext);
    const [toPSignStatus, setTopSignStatus] = useState(SIGN_STATUS.CHECKING);

    useEffect(() => {
        // TODO: If the API call below fails, the status remains "CHECKING" and the user is left in an indefinite loading state.
        // Proper error handling should be implemented to update the status and inform the user of the failure.
        getToPDigitalSignatureContract(url, authContext).then((res) => {
            const status = _.get(res.data, 'status', SIGN_STATUS.UNSIGNED);
            setTopSignStatus(status);
            // updating the field value to account for centralized form fields validation
            props.onStatusChange(status);
        });
    }, []);

    let subHeaderText =
        'Please digitally sign via Adobe Sign to continue the onboarding process';
    let ButtonComponent;
    switch (toPSignStatus) {
        case SIGN_STATUS.CHECKING:
            ButtonComponent = <SignStatusCheck />;
            break;
        case SIGN_STATUS.SIGNED:
            ButtonComponent = (
                <DocumentSignedButton message="Successfully Signed" />
            );
            subHeaderText =
                'You have successfully signed the Terms of Participation via Adobe Sign';
            break;
        default:
            ButtonComponent = (
                <SignWithAdobeSignButton
                    overlay={
                        <AdobeSignRedirectDisclaimer
                            createContract={createToPDigitalSignatureContract}
                            getSigningUrl={getToPDigitalSignatureSigningUrl}
                            message="You will be taken to Adobe Sign platform to digitally sign the Terms of Participation. After successfully signing, you will be redirected back to the ICP Onboarding application to complete the process."
                        />
                    }
                />
            );
    }

    return (
        <div className="md:grid md:grid-cols-2">
            <div className="justify-self-start">
                <div className="font-bold text-base">
                    Digitally sign via Adobe Sign
                </div>
                <div className="text-gray-500">{subHeaderText}</div>
            </div>
            <div className="flex justify-center md:justify-self-end mt-2 md:mt-1 mr-9 md:mr-6 md:ml-20 md:w-3/5 md:w-max">
                {ButtonComponent}
            </div>
        </div>
    );
};

SignToPViaDigitalSignatureButton.propTypes = {
    onStatusChange: PropTypes.func,
};

export { SignToPViaDigitalSignatureButton };
